import React from 'react';
import './HeaderSignUp.css';

export default function HeaderSignUp() {
  return (
    <div className="header-signup">
        <h1 className="heading-signup">Feedback</h1>
        <p className="content-signup">Add your products and give us your valuable feedback</p>
    </div>
  )
}
